import React, { createContext, useState, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export function useTheme() {
  return useContext(ThemeContext);
}

export function ThemeProvider({ children }) {
  // Check if theme exists in localStorage or use light theme as default
  const getInitialTheme = () => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'light';
  };

  const [theme, setTheme] = useState(getInitialTheme);

  // Update CSS variables when theme changes
  useEffect(() => {
    if (theme === 'light') {
      document.documentElement.style.setProperty('--color-bg', '#f8fafc');
      document.documentElement.style.setProperty('--color-text', '#0f172a');
      document.documentElement.style.setProperty('--color-primary', '#2563eb');
      document.documentElement.style.setProperty('--color-primary-hover', '#3b82f6');
      document.documentElement.style.setProperty('--color-secondary', '#e2e8f0');
      document.documentElement.style.setProperty('--color-secondary-hover', '#cbd5e1');
      document.documentElement.style.setProperty('--color-danger', '#ef4444');
      document.documentElement.style.setProperty('--color-success', '#10b981');
      document.documentElement.style.setProperty('--color-border', '#cbd5e1');
      document.documentElement.style.setProperty('--color-input-bg', '#ffffff');
      document.documentElement.style.setProperty('--color-card-bg', '#ffffff');
    } else {
      document.documentElement.style.setProperty('--color-bg', '#000000');
      document.documentElement.style.setProperty('--color-text', '#ffffff');
      document.documentElement.style.setProperty('--color-primary', '#2563eb');
      document.documentElement.style.setProperty('--color-primary-hover', '#3b82f6');
      document.documentElement.style.setProperty('--color-secondary', '#1e293b');
      document.documentElement.style.setProperty('--color-secondary-hover', '#334155');
      document.documentElement.style.setProperty('--color-danger', '#ef4444');
      document.documentElement.style.setProperty('--color-success', '#10b981');
      document.documentElement.style.setProperty('--color-border', '#334155');
      document.documentElement.style.setProperty('--color-input-bg', '#1e293b');
      document.documentElement.style.setProperty('--color-card-bg', '#111827');
    }

    // Save to localStorage
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prevTheme => prevTheme === 'dark' ? 'light' : 'dark');
  };

  const value = {
    theme,
    toggleTheme,
    isDark: theme === 'dark'
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
} 